(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name flightWatch.controller:FlightWatchSendNotificationCtrl
   *
   * @description
   *
   */
  angular
    .module('flightWatch')
    .controller('FlightWatchSendNotificationCtrl', FlightWatchSendNotificationCtrl);

  function FlightWatchSendNotificationCtrl(modalParams, CommonMasterData, FlightWatch, $uibModalInstance, MessageService, PopupManager, CommonLogicService, EventManagerService, RemoteService, $scope, CrewingSelectionHelper) {

    var vm = this;
    vm.selectedFlightLegIds = [];
    vm.selectedFlightLegOrigin = null;
    vm.selectedFlightLegDestination = null;
    vm.selectedFlightLegEstimatedDepartureTime = null;
    vm.selectedFlightLegOriginalDepartureTime = null;
    vm.flightIsDelayed = null;
    vm.flightIsCancelled = null;
    vm.otherNotificationData = null;
    vm.notificationType = null;
    vm.delayMessage = null;
    vm.changeMessage = null;
    vm.cancelMessage = null;
    vm.otherMessage = null;
    vm.flightLegDetails = [];
    vm.defaultMessageList = [];

    //selected flight legs
    vm.selectedNotificationItems = modalParams.modelValue.notificationItems;

    vm.selectedNotificationItems.forEach(function (selectedNotificationItem) {
      var flightCrewNotificationRequest ={};

      if(selectedNotificationItem.flightLegId !== null || selectedNotificationItem.flightLegId !== undefined){
        flightCrewNotificationRequest.flightLegId = selectedNotificationItem.flightLegId;
        // can be add # NEED TO CLARIFY Items here
      }

      FlightWatch.loadDefaultMessagesByFlightLeg(flightCrewNotificationRequest, function (response) {
        // set checkbox model
        response.flightDetailResponse.isChecked = true;
        response.flightDetailResponse.notificationType = response.notificationType;
        vm.flightLegDetails.push(response.flightDetailResponse);
        var messageMap = {
          flightLegId :  response.flightDetailResponse.flightLegId,
          messageList : response.defaultMessages
        };
        vm.defaultMessageList.push(messageMap)
      });
    });

    vm.notificationTypeChange = function (notificationItem) {
      var message = "";
      var notificationType = notificationItem.notificationType;

      var defaultMessageForFlightLeg = _.find(vm.defaultMessageList, function (messageList) {
        return messageList.flightLegId === notificationItem.flightLegId;
      });

      if ("FLT_DELAY_SMS" === notificationType) {
        message = _.find(defaultMessageForFlightLeg.messageList, function (obj) { return obj.messageKey === "FLT_DELAY_SMS"; }).messageValue;
      } else if ("FLT_CHANGE_SMS" === notificationType) {
        message = _.find(defaultMessageForFlightLeg.messageList, function (obj) { return obj.messageKey === "FLT_CHANGE_SMS"; }).messageValue;
      } else if ("FLT_CANCEL_SMS" === notificationType) {
        message = _.find(defaultMessageForFlightLeg.messageList, function (obj) { return obj.messageKey === "FLT_CANCEL_SMS"; }).messageValue;
      } else if ("FLT_OTHER_SMS" === notificationType) {
        message = _.find(defaultMessageForFlightLeg.messageList, function (obj) { return obj.messageKey === "FLT_OTHER_SMS"; }).messageValue;
      }
      notificationItem.message = message;
    };

    vm.closeSendNotificationPopUp = function () {
      /*modalParams.modelValue.successCallback();*/
      $uibModalInstance.close();
    };

    vm.checkFlightIsDelayed = function () {
      if ((vm.selectedFlightLegEstimatedDepartureTime != vm.selectedFlightLegOriginalDepartureTime)) {
        vm.flightIsDelayed = true;
      }
      else {
        vm.flightIsDelayed = false;
      }
    };


    vm.validateAndSendNotification = function(){
      vm.frmEditor.$valid;
      var flightCrewNotificationRequests = [];
      vm.flightLegDetails.forEach(function (flightLegDetail) {
        var flightCrewNotificationRequest = {};

        if(flightLegDetail.isChecked){
          flightCrewNotificationRequest.flightLegId = flightLegDetail.flightLegId;
          flightCrewNotificationRequest.message = flightLegDetail.message;
          flightCrewNotificationRequest.reason = flightLegDetail.notificationType;

          flightCrewNotificationRequests.push(flightCrewNotificationRequest);
        }
      });

      if(flightCrewNotificationRequests.length > 0){
        sendSelectedNotifications(flightCrewNotificationRequests);
      } else {
        MessageService.error(MessageService.MESSAGES.SEND_NOTIFICATION.NOTIFICATION_NOT_CHECKED_ANY);
      }
    };

    function sendSelectedNotifications (notificatioanRequestParam) {
      FlightWatch.sendFlightCrewNotifications(notificatioanRequestParam,
        function (response) {
          if (response.success) {
            modalParams.modelValue.successCallback();
            $uibModalInstance.close();
            MessageService.success(MessageService.MESSAGES.SEND_NOTIFICATION.NOTIFICATION_SEND_SUCCESS);
          }
        },
        function(error) {
          MessageService.error(error.msg[0]);
        });
    }
  }

}());
